var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visualTraining"},[_c('iframe',{ref:"prints",attrs:{"src":"http://www.visumall.com/Visumallhdp/Index2.html","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }